import { render, staticRenderFns } from "./carSeries.vue?vue&type=template&id=019fcc85&scoped=true"
import script from "./carSeries.vue?vue&type=script&lang=js"
export * from "./carSeries.vue?vue&type=script&lang=js"
import style0 from "./carSeries.vue?vue&type=style&index=0&id=019fcc85&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019fcc85",
  null
  
)

export default component.exports